<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: calc(100% - 20px);margin: 0 20px;padding-top: 20px">
      <el-row style="height: 100%;">
<!--        <el-col :span="4" style="height: 100%;">-->
<!--          <tree-organize ref="org" :treeObj="treeObj" @getOrgArr="getOrgArr"></tree-organize>-->
<!--        </el-col>-->
        <el-col :span="24" style="height: 100%;">
          <div style="height: 100%;margin: 0 20px">
            <div style="height: 50px;">
              <el-button type="primary" plain icon="el-icon-plus" @click="addOpen()">办理入住</el-button>
              <el-select v-fixZoom v-model="filterType" placeholder="请选择" style="width: 130px">
                <el-option v-for="item in filterTypeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-input v-model="filterText" prefix-icon="el-icon-search" placeholder="请输入" clearable style="width: 250px"></el-input>
              <el-select v-fixZoom v-model="stateType" placeholder="请选择" multiple style="width: 250px">
                <el-option v-for="item in stateTypeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <el-button type="success" @click="getSearchData">查询</el-button>
            </div>
            <div style="height: calc(100% - 100px)">
              <el-table :data="tableData" border highlight-current-row height="100%">
                <el-table-column
                  type="index"
                  label="序号"
                  width="70"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="person_name"
                  label="老人姓名"
                  min-width="120"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="老人性别"
                  min-width="80"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getSexDesc(scope.row.sex)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="老人生日"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{scope.row.birthday}}</span>
                    <br>
                    <span>{{getAgeDesc(scope.row.birthday)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="所在床位"
                  min-width="120"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getBedDesc(scope.row)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="失能"
                  min-width="60"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getDisabledElderlyDesc(scope.row.disabled_elderly)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="照护等级"
                  min-width="80"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getCareLevelDesc(scope.row.care_level)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="diet_level"
                  label="饮食级别"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="esp_name"
                  label="办理人员"
                  min-width="80"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="入住时间"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getTimeDesc(scope.row.create_time)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="退住时间"
                  width="100"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getTimeDesc(scope.row.leave_time)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="80"
                  align="center">
                  <template slot-scope="scope">
                    <span>{{getCurentStateDesc(scope.row.curent_state)}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="380">
                  <template slot-scope="scope">
                    <el-button size="mini" type="primary" plain @click="editFace(scope.row)">门禁</el-button>
                    <el-button size="mini" type="primary" plain @click="openOldPerson(scope.row)">老人档案</el-button>
<!--                    <el-button v-if="scope.row.is_can_request_leave === '0'" :disabled="scope.row.curent_state === 1 || scope.row.is_can_request_leave === '0'" size="mini" type="info" plain>请假</el-button>-->
<!--                    <el-button v-else size="mini" type="primary" plain @click="requestLeave(scope.row)">{{scope.row.curent_state === 1 ? '取消请假' : '请假'}}</el-button>-->
<!--                    <el-button size="mini" type="primary" plain @click="changeBed(scope.row)">床位变更</el-button>-->
<!--                    <el-button size="mini" type="primary" plain @click="checkOut(scope.row)">{{scope.row.curent_state === 2 ? '取消退住' : '申请退住'}}</el-button>-->
                    <el-button size="mini" type="primary" plain @click="editOpen(scope.row)">修改</el-button>
                    <!--                   <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="openEdit(scope.row)"></i>-->
<!--                <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="openDel(scope.row)"></i>-->
                    <el-dropdown v-fixZoom style="margin-left: 10px" size="small" @command="(command) => handleCommand(command, scope.row)">
                      <span class="el-dropdown-link">
<!--                      更多<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                        <el-button size="mini" type="primary" plain>变更状态<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></el-button>
                      </span>
                      <el-dropdown-menu v-fixZoom slot="dropdown">
                        <el-dropdown-item command="handleSetEService">护理设置</el-dropdown-item>
                        <el-dropdown-item v-if="scope.row.curent_state !== 1" :disabled="scope.row.curent_state === 2" command="handleAskLeave">请假</el-dropdown-item>
                        <el-dropdown-item v-else command="handleAskLeaveCancel">结束请假</el-dropdown-item>
                        <el-dropdown-item command="handleChangeBed">床位变更</el-dropdown-item>
                        <el-dropdown-item v-if="scope.row.curent_state !== 2" :disabled="scope.row.curent_state === 1" command="handleLeave">申请退住</el-dropdown-item>
                        <el-dropdown-item v-else command="handleLeaveCancel">取消退住</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="margin-top: 10px;height: 40px;text-align: center">
              <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                             :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                             layout="total, sizes, prev, pager, next, jumper">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="addHomeBedPersonShow" v-if="addHomeBedPersonShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-old-person :setHomeBedPersonObj="setHomeBedPersonObj" v-model="addHomeBedPersonShow" @updateTable="updateTable"></add-old-person>
    </el-dialog>
    <el-dialog :visible.sync="oldPersonInfoShow" v-if="oldPersonInfoShow" width="950px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{oldPersonInfoObj.elderlyName}}档案</span>
        <div class="line-title"></div>
      </div>
      <old-person-info-list :oldPersonInfoObj="oldPersonInfoObj" v-model="oldPersonInfoShow"></old-person-info-list>
    </el-dialog>
    <el-dialog :visible.sync="askLeaveShow" v-if="askLeaveShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>请假</span>
        <div class="line-title"></div>
      </div>
      <ask-leave :homeBedPersonObj="listObj" v-model="askLeaveShow" @updateTable="updateTable"></ask-leave>
    </el-dialog>
    <el-dialog :visible.sync="bedShow" v-if="bedShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>床位变更</span>
        <div class="line-title"></div>
      </div>
      <change-bed-open :listObj="listObj" v-model="bedShow" @updateTable="updateTable"></change-bed-open>
    </el-dialog>
    <el-dialog :visible.sync="checkOutShow" v-if="checkOutShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>退住</span>
        <div class="line-title"></div>
      </div>
      <check-out :home-bed-person-obj="listObj" v-model="checkOutShow" @updateTable="updateTable"></check-out>
    </el-dialog>
    <el-dialog :visible.sync="setEServiceShow" v-if="setEServiceShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>护理设置</span>
        <div class="line-title"></div>
      </div>
      <set-e-service :listObj="listObj" v-model="setEServiceShow"></set-e-service>
    </el-dialog>
    <!--  门禁列表  -->
    <el-dialog :visible.sync="faceDeviceShow" v-if="faceDeviceShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{ listObj.row.person_name }} - 门禁列表</span> </div>
        <div class="line-title"></div>
      </div>
      <face-device-list :listObj="listObj" v-model="faceDeviceShow"></face-device-list>
    </el-dialog>
  </div>
</template>

<script>
import treeOrganize from './components/treeOrganize'
import addOldPerson from './components/addOldPerson'
import oldPersonInfoList from './components/oldPersonInfoList'
import changeBedOpen from './components/changeBedOpen'
import {queryhomebedelderly} from '../../api/yanglaoyuan/homebed'
import askLeave from './components/askLeave'
import checkOut from './components/checkOut'
import setEService from './components/setEService'
import faceDeviceList from './components/faceDeviceList.vue'
export default {
  name: 'checkIn',
  components: {setEService, checkOut, askLeave, treeOrganize, addOldPerson, oldPersonInfoList, changeBedOpen, faceDeviceList},
  data () {
    return {
      loading: false,
      treeOrg: [],
      treeNode: '',
      treeObj: {
        orgData: [],
        elderlys: [],
        homebeds: []
      },

      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      stateTypeArr: [{id: 0, name: '正常'}, {id: 1, name: '请假'}, {id: 2, name: '申请退住'}],
      stateType: [0, 1, 2],
      filterTypeArr: [{id: 1, name: '老人姓名'}, {id: 2, name: '房间名称'}, {id: 3, name: '床位名称'}],
      filterType: 1,
      filterText: '',
      careLevelArr: [],

      tableData: [],
      addEditTitle: '',
      addHomeBedPersonShow: false,
      setHomeBedPersonObj: {
        isAdd: true,
        row: ''
      },

      listObj: {
        openType: 0,
        row: ''
      },
      oldPersonInfoObj: {
        id: 0,
        elderlyName: ''
      },
      // 老人档案
      oldPersonInfoShow: false,
      // 变更床位
      bedShow: false,
      // 请假
      askLeaveShow: false,
      // 退住
      checkOutShow: false,
      // 护理设置
      setEServiceShow: false,
      // 门禁列表
      faceDeviceShow: false
    }
  },
  created () {
    // console.log()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.careLevelArr = this.commonType.getCareLevelArr()
    this.getSearchData()
  },
  methods: {
    getOrgArr (obj) {
      if (obj.type === 'org') {
        this.treeOrg = obj.arr
      } else if (obj.type === 'node') {
        // 点击树组织
        this.treeNode = obj.node
      }
    },
    getSearchData () {
      this.getHomebedElderlyData()
    },
    updateTable () {
      this.getHomebedElderlyData()
    },

    handleCommand (command, row) {
      switch (command) {
        case 'handleSetEService':
          this.setEService(row)
          break
        case 'handleAskLeave':
          this.requestLeave(row, 0)
          break
        case 'handleAskLeaveCancel':
          this.requestLeave(row, 1)
          break
        case 'handleChangeBed':
          this.changeBed(row)
          break
        case 'handleLeave':
          this.checkOut(row, 0)
          break
        case 'handleLeaveCancel':
          this.checkOut(row, 1)
          break
        default:
          break
      }
    },
    setEService (row) {
      this.listObj.openType = 1
      this.listObj.row = row
      this.setEServiceShow = true
    },
    // 请假/取消请假 type为1为取消
    requestLeave (row, type) {
      if (type === 1) {
        // 取消请假
        this.listObj.openType = 0
      } else {
        // 请假
        this.listObj.openType = 1
      }
      this.listObj.row = row
      this.askLeaveShow = true
    },
    // 门禁
    editFace (row) {
      this.listObj.row = row
      this.faceDeviceShow = true
    },
    // 变更床位
    changeBed (row) {
      this.listObj.row = row
      this.bedShow = true
    },
    // 老人档案
    openOldPerson (row) {
      this.oldPersonInfoObj.id = row.epid
      this.oldPersonInfoObj.elderlyName = row.elderly_name
      this.oldPersonInfoShow = true
    },
    // 新增入住
    addOpen () {
      this.addEditTitle = '办理入住'
      this.setHomeBedPersonObj.isAdd = true
      this.addHomeBedPersonShow = true
    },
    editOpen (row) {
      this.addEditTitle = '修改入住'
      this.setHomeBedPersonObj.row = row
      this.setHomeBedPersonObj.isAdd = false
      this.addHomeBedPersonShow = true
    },
    // 申请退住/取消退住 type为1取消
    checkOut (row, type) {
      if (type === 1) {
        // 取消退住
        this.listObj.openType = 2
      } else {
        // 申请退住
        this.listObj.openType = 1
      }
      this.listObj.row = row
      this.checkOutShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    // table显示
    // 获取性别描述
    getSexDesc (sex) {
      return this.util.getSex(sex)
    },
    // 获取年龄描述 ****-**-**/age
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    // 获取所在床位
    getBedDesc (row) {
      let result = ''
      result = row.build_name + '/' + row.floor_name + '/' + row.room_name + '/' + row.bed_name
      return result
    },
    // 获取失能状态描述
    getDisabledElderlyDesc (disabledElderly) {
      let result = '否'
      if (disabledElderly === '1') {
        result = '是'
      }
      return result
    },
    // 获取护理等级描述
    getCareLevelDesc (careLevel) {
      let result = '未知'
      let careLevelObj = this.careLevelArr.find(r => r.id === careLevel.toString())
      if (careLevelObj) {
        result = careLevelObj.name
      }
      return result
    },
    // 获取居住状态描述
    getCurentStateDesc (curentState) {
      let result = ''
      let stateType = this.stateTypeArr.find(r => r.id === parseInt(curentState))
      if (stateType) {
        result = stateType.name
      }
      return result
    },
    getTimeDesc (time) {
      let dateTime = new Date(time)
      return dateTime.format('yyyy-MM-dd')
    },

    // 访问接口
    // 查询入院列表
    getHomebedElderlyData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.entityId === 0 ? -1 : this.entityId,
        curent_state: this.stateType,
        elderly_name: this.filterType === 1 ? this.filterText : '',
        room_name: this.filterType === 2 ? this.filterText : '',
        bed_name: this.filterType === 3 ? this.filterText : ''
      }
      queryhomebedelderly(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.homebedperson
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/checkIn.vue